<template>
    <div class="col-lg-9">
        <small class="text-muted text-1 mb-2">
            <router-link
                :to="`/business/dashboard`"
                class="font-weight-500 mr-2"
            >
                <i class="fas fa-home"></i>
            </router-link>

            <i class="fas fa-chevron-right mr-2"></i>
            <router-link
                :to="`/business/stored-accounts`"
                class="font-weight-500 mr-2"
            >
                Groups
            </router-link>
            <i class="fas fa-chevron-right mr-2"></i>
            Group - {{ groupName }}
        </small>
        <div class="mb-3"></div>
        <div class="d-flex align-items-center mb-4">
            <h4 class="text-7 mb-0 flex-grow-1 d-inline-block position-relative">
                <span class="position-relative d-inline-block d-flex align-items-center">
                    <span class="d-flex flex-row">
                         <span class="text-7" v-if="!isEditingGroupName">{{ groupName }}</span>
                        <button v-if="!isEditingGroupName" @click="enableEditGroupName" class="btn btn-sm btn-link  text-muted p-0 ml-2">
                            <i class="fas fa-edit"></i> <small>Edit</small>
                        </button>
                    </span>
                    <span class="d-flex flex-row">
                         <input
                             v-if="isEditingGroupName"
                             type="text"
                             v-model="editedGroupName"
                             class="form-control form-control-sm edit-input mr-2"
                             placeholder="Enter group name"
                         />

                        <button v-if="isEditingGroupName" :disabled="!editedGroupName" @click="saveGroupName" class="btn btn-sm btn-link text-success p-0 ml-2">
                            <i class="fas fa-save"></i>
                        </button>
                        <button v-if="isEditingGroupName" @click="disableEditGroupName" class="btn btn-sm btn-link text-success p-0 ml-2">
                            <i class="fas fa-times-circle"></i>
                        </button>
                    </span>
                    <span v-if="form.errors.get('group_name')" class="invalid-feedback d-block text-1">
                        {{ form.errors.get('group_name') }}
                    </span>
                </span>
            </h4>

            <router-link
                :to="`/business/stored-accounts/create-batch`"
                class="btn btn-success btn-sm text-white shadow-none"
            >
                <i class="fas fa-layer-group mr-2"></i>Add/Update Batch
            </router-link>
        </div>
        <ErrorAlert :message="message" :error="error" />
        <hr>
        <p class="d-flex flex-row align-items-center">
                <span>
                     <i class="fas fa-info-circle mr-2"></i>
                </span>
            <span>
                     Batches help businesses categorize and process related stored accounts together, improving organization and workflow.
                </span>
        </p>
        <hr>
        <!-- Edit Mode -->

        <form @submit.prevent="data.fetch()" class="row my-4 align-items-center pr-3">
            <div class="col-lg-2">
                <select @change="data.fetch()" v-model="data.filters.size" class="custom-select" required>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="25">25</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
            </div>
            <div class="input-group col-lg-4 ml-auto">
                <div class="input-group-prepend">
                    <span class="input-group-text bg-white"><i class="fas fa-search"></i></span>
                </div>
                <input type="text" class="form-control" v-model="data.filters.search" placeholder="Search">
            </div>

            <button @click.prevent="data.fetch()"
                    :class="['btn btn-primary btn-sm text-white px-3 shadow-none', data.loading ? 'btn-loading' : '']">
                <i class="fas fa-arrow-alt-circle-right"></i>
            </button>
        </form>

        <!-- Stored Accounts Table -->
        <div class="bg-light shadow-sm rounded py-4 mb-4">
            <div class="d-flex justify-content-start align-items-center mb-4 px-4">
                <div class="mb-0">
                    <h3 class="text-4 font-weight-700 mb-0">
                        Batches
                    </h3>
                </div>
            </div>
            <!-- Title =============================== -->
            <div class="transaction-title py-2 px-4">
                <div class="row">
                    <div class="col-2 col-sm-3"><span class="">Name</span></div>
                    <div class="col col-sm-2 d-none d-sm-block ">Type</div>
                    <div class="col col-sm-2 d-none d-sm-block ">Accounts</div>
                    <div class="col col-sm-2 d-none d-sm-block ">Status</div>
                    <div class="col-auto col-sm-3 text-right">Actions</div>

                </div>
            </div>
            <!-- Title End -->

            <!-- Transaction List
            =============================== -->
            <div class="transaction-list">
                <div v-if="data.content.data.length === 0" class="p-4">
                    <div class="table-responsive">
                        <div class="col-sm-12 col-md-12">
                            <div class="hover-border hover-section text-center px-3 py-4">
                                    <span class="d-block text-10 text-light mt-2 mb-3">
                                        <i class="fas fa-layer-group service-icon"></i>
                                    </span>
                                <p class="mb-0 text-3 service-text">
                                    <b>You do not have any Batches </b>
                                </p>
                                <div class="mt-3">
                                    <router-link
                                        :to="`/business/stored-accounts/create-batch`"
                                        class="btn btn-primary btn-sm text-white shadow-none ml-auto"
                                    >
                                        <i class="fas fa-plus-circle mr-2"></i>Add Batch
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else v-for="row in data.content.data" :key="row.id" class="transaction-item d-block px-4 py-3">
                    <div class="row align-items-center flex-row">
                        <div class="col col-sm-3">
                            <span class="row-text">{{ row.batch_name }}</span>
                        </div>
                        <div class="col col-sm-2">
                            <span class="row-text">{{ row.account_type}}</span>
                        </div>
                        <div class="col col-sm-2 d-none d-sm-block">
                            <span class="row-text">{{ row.accounts_count || 0 }}</span>
                        </div>
                        <div class="col col-sm-2">
                            <span class="row-text">{{ row.status}}</span>
                        </div>
                        <div class="col col-sm-3 d-flex justify-content-end">
                            <router-link
                                :to="`/business/stored-accounts/${row.id}/batch`"
                                class="btn btn-primary btn-sm btn-extra-small mr-2"
                            >
                                <i class="fas fa-eye"></i>
                            </router-link>
                            <button @click="confirmSuspend(row)"
                                    :class="['btn btn-sm btn-extra-small', row.status === 'ACTIVE' ? 'btn-outline-success' : 'btn-success']">
                                <i :class="row.status === 'ACTIVE' ? 'fas fa-ban' : 'fas fa-check'"></i>
                                {{ row.status === 'ACTIVE' ? 'Suspend' : 'Activate' }}
                            </button>
                            <button @click="confirmDelete(row)"
                                    class="btn btn-danger btn-sm btn-extra-small ml-2">
                                <i class="fas fa-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>

            </div>
            <!-- Transaction List End -->

            <!-- Pagination ============================================= -->
            <div class="d-flex align-items-center justify-content-between px-4">
                <span class="text-black-50">
                    Showing {{ data.content.data.length }} of {{ data.content.total }} Records
                </span>
                <ul class="pagination justify-content-center mt-4 mb-0">
                    <li class="page-item disabled">
                        <a class="page-link" href="#" tabindex="-1">
                            <i class="fas fa-angle-left"></i>
                        </a>
                    </li>
                    <li class="page-item active">
                        <a @click="data.append()"
                           v-if="data.content.total !== data.content.to && data.content.data.length > 0"
                           class="page-link" href="#">
                            Load More <span class="sr-only">(current)</span>
                        </a>
                    </li>
                    <li class="page-item d-flex align-content-center flex-wrap text-muted text-5 mx-1">
                        <span>...</span>
                    </li>
                    <li class="page-item disabled">
                        <a class="page-link" href="#" tabindex="-1">
                            <i class="fas fa-angle-right"></i>
                        </a>
                    </li>
                </ul>
            </div>
            <!-- Paginations end -->
        </div>
    </div>
    </div>
</template>

<script>
import Data from "../../../core/data/Data";
import Form from "../../../core/forms/form";
import ErrorAlert from "../components/ErrorAlert.vue";


export default {
    name: "Index",
    components: {ErrorAlert},
    data() {
        return {
            data: new Data({
                url: `/business/business-stored-accounts/groups/${this.$route.params.id}/batches/list`,
                prefix: "list"
            }),
            form: new Form({
                group_name: '',
            }),
            showModal: false,
            selectedAccount: {},
            isEditingGroupName: false,
            groupName: "Group Name",
            displayGroupName: "",
            editedGroupName: "",
            message: '',
            error:false
        };
    },
    methods: {
        fetchGroupName() {
            axios.get(`/business/business-stored-accounts/groups/${this.$route.params.id}`)
                .then(response => {
                    this.groupName = response.data.body.group.group_name;
                    this.displayGroupName = response.data.body.group.group_name;
                })
                .catch(() => {
                    this.$toast.error("Error fetching group name", {
                        timeout: 3000
                    });
                });
        },

        enableEditGroupName() {
            this.editedGroupName = this.groupName;
            this.isEditingGroupName = true;
        },

        disableEditGroupName() {
            this.editedGroupName = this.groupName;
            this.isEditingGroupName = false;
        },

        saveGroupName() {
            this.form.fill('group_name', this.editedGroupName);

            this.form.submit(`/business/business-stored-accounts/groups/${this.$route.params.id}/update`)
                .then(() => {
                    this.fetchGroupName();
                    this.isEditingGroupName = false;
                    this.$toast.success("Group name updated successfully!", {
                        timeout: 3000
                    });
                })
                .catch(() => {
                    this.$toast.error("Error updating group name. Please try again.", {
                        timeout: 3000
                    });
                });
        },


        confirmSuspend(batch) {
            let newStatus = batch.status === 'ACTIVE' ? 'SUSPENDED' : 'ACTIVE';
            let confirmationMessage = `Are you sure you want to ${newStatus === 'ACTIVE'? 'ACTIVATE': 'SUSPEND'} the batch "${batch.batch_name}"?`;
            window.alerts.confirm(confirmationMessage).then((confirmed) => {
                if (confirmed) {
                    this.setBatchStatus(batch, newStatus);
                    this.data.fetch();
                }
            });
        },

        setBatchStatus(batch, status) {
            axios.put(`/business/business-stored-accounts/batches/${batch.id}/status/${status}`)
                .then(response => {
                    window.alerts.success(`Batch ${status} successfully`).then(() => {
                        this.data.fetch();
                    });
                })
                .catch(error => {
                    window.alerts.error(error.response);
                });
        },

        confirmDelete(batch) {
            let confirmationMessage = `Are you sure you want to delete the batch "${batch.batch_name}"? This action cannot be undone.`;
            window.alerts.confirm(confirmationMessage).then((confirmed) => {
                if (confirmed) {
                    this.deleteBatch(batch);
                    this.data.fetch();
                }
            });
        },

        deleteBatch(batch) {
            axios.delete(`/business/business-stored-accounts/batches/${batch.id}`)
                .then(response => {
                    window.alerts.success(response.data.message).then(() => {
                        this.data.fetch();
                    });
                })
                .catch(error => {
                    window.alerts.error(error.response);
                });
        }
    },

    mounted() {
        this.data.fetch();
        this.fetchGroupName();
    }
};
</script>

<style scoped>
.row-text{
    color: #252c65;
}
.btn-extra-small {
    padding: 6px 6px;
    font-size: 12px;
    line-height: 1.2;
}
.d-flex {
    transition: all 0.3s ease;
}

.form-control-sm {
    border-radius: 4px;
    border: 1px solid #ddd;
    padding: 6px 12px;
    font-size: 14px;
}
.btn-success:hover {
    background-color: #28a745;
    border-color: #28a745;
}

.edit-input {
    width: 70%;
    min-width: 200px;
    max-width: 300px;
}
</style>
